import { endpoints } from 'zylo_schema/contracts/endpoints';
type postResponse = endpoints['get_posts']['responses'];
type R<T> = T extends { status: 200 } ? T : never;
export type post = R<postResponse>['data']['posts'][0];

export const postsStore: post[] = [
  {
    id: 0,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Begur',
      country_code: 'ES',
      lat: 41.93858959999999,
      lng: 3.2157601,
    },
    description: 'Summer bliss at Aigua Blava - crystal-clear waters and serene coastal views making memories unforgettable. #Summer2024 #AiguaBlava',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Absolutely love Aigua Blava! Been staying at this hotel every summer since 1988, and it never disappoints. #Tradition #AiguaBlavaMemories',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'Looks amazing! Adding it to my travel list.',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Do they allow pets at the hotel?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Begur-Hotels-Hotel-Aiguablava.h1133306.Hotel-Information',
    hotelName: 'Hotel Aigua Blava',
    images: [
      'spain.png',
      'greece.png',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 1,
    user_id: 3,
    user_name: 'James Sinclair',
    location: {
      city: 'Athens',
      country_code: 'GR', lat: 37.976986,
      lng: 23.731955,
    },
    description: 'The last few weeks have been unbelievable! #GatsbyAthensHotel',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Next summer Inshallah!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Athens is magical in spring!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Athens-Hotels-Gatsby-Athens.h45266187.Hotel-Information',
    hotelName: 'Gatsby Athens Hotel',
    images: [
      'greece.png',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 2,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Rio de Janeiro',
      country_code: 'BR',
      lat: -22.9980396,
      lng: -43.25682079999999,
    },
    description: 'Really enjoying all the culture in Rio! #GranMeliáNacional',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'You should definitely visit the photography museum there!',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'Don’t miss the samba nights!',
      },
    ],
    hotelUrl: 'https://www.expedia.co.in/Rio-De-Janeiro-Hotels-Hotel-Nacional-Rio.h42275495.Hotel-Information',
    hotelName: 'Gran Meliá Nacional',
    images: [
      'brazil.png',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 3,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Amalfi',
      country_code: 'IT',
      lat: 40.7697189,
      lng: 14.7980005,
    },
    description: 'Breathtaking views and lemon-scented breezes in Amalfi! #HotelSantaCaterina',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'That looks magical! Amalfi is on my bucket list.',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you try the famous Amalfi lemons?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Amalfi-Hotels-Santa-Caterina.h2541496.Hotel-Information',
    hotelName: 'Hotel Santa Caterina',
    images: [
      'italy.webp',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 4,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7646318,
      lng: -73.9743251,
    },
    description: 'Feeling on top of the world in NYC! #ThePlazaHotel',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Don’t forget to check out the MET rooftop garden!',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'What’s the best place for brunch nearby?',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'You must see Times Square at night!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-Plaza-Hotel.h28044.Hotel-Information',
    hotelName: 'The Plaza Hotel',
    images: [
      'usa.webp',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 5,
    user_id: 0,
    user_name: 'Dana D',
    location: {
      city: 'Cabo San Lucas',
      country_code: 'MX',
      lat: 22.8747501,
      lng: -109.912132,
    },
    description: 'Sun, sand, and endless relaxation in Cabo. #WaldorfAstoriaCabo',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Wishing I was there! Looks amazing.',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'Cabo is such a dream destination!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Los-Cabos-Hotels-Waldorf-Astoria-Los-Cabos-Pedregal.h2256238.Hotel-Information',
    hotelName: 'Waldorf Astoria Cabo',
    images: [
      'mexico.webp',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 6,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'London',
      country_code: 'GB',
      lat: 51.5070782,
      lng: -0.1416273,
    },
    description: 'Tea, history, and modern charm. London has it all! #TheRitzLondon',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you try the afternoon tea there?',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'I recommend the British Museum!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/London-Hotels-The-Ritz-London.h28146.Hotel-Information',
    hotelName: 'The Ritz London',
    images: [
      'uk.webp',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 7,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'Tokyo',
      country_code: 'JP',
      lat: 35.6854999,
      lng: 139.6907386,
    },
    description: 'Cherry blossoms and neon nights. Tokyo is unforgettable. #ParkHyattTokyo',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Don’t miss the Shinjuku Gyoen Garden this season!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'How was the sushi at Tsukiji Market?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Tokyo-Hotels-Park-Hyatt-Tokyo.h969939.Hotel-Information',
    hotelName: 'Park Hyatt Tokyo',
    images: [
      'japan.webp',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 8,
    user_id: 3,
    user_name: 'James Sinclair',
    location: {
      city: 'Paris',
      country_code: 'FR',
      lat: 48.86518880000001,
      lng: 2.3280831,
    },
    description: 'The city of lights never loses its charm. #HôtelLeMeurice',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Catch the Eiffel Tower at night. It’s stunning!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Any good bakery recommendations?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Paris-Hotels-Le-Meurice-Dorchester-Collection.h441665.Hotel-Information',
    hotelName: 'Hôtel Le Meurice',
    images: [
      'france.webp',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 9,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'Dubai',
      country_code: 'AE',
      lat: 25.1411914,
      lng: 55.18524679999999,
    },
    description: 'Skyscrapers, luxury, and desert adventures. #BurjAlArab',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Dubai is truly a traveler’s paradise!',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Don’t miss the desert safari!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Dubai-Hotels-Burj-Al-Arab-Jumeirah.h527497.Hotel-Information',
    hotelName: 'Burj Al Arab',
    images: [
      'uae.webp',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 10,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Jebel Akhdar',
      country_code: 'OM',
      lat: 23.067768,
      lng: 57.670095,
    },
    description: 'Mountain breezes and Omani hospitality. #AnantaraAlJabalAlAkhdar',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'A perfect getaway to recharge!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'The views are out of this world!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Sayq-Hotels-Anantara-Al-Jabal-Al-Akhdar-Resort.h15161725.Hotel-Information',
    hotelName: 'Anantara Al Jabal Al Akhdar',
    images: [
      'oman.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 11,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Bangkok',
      country_code: 'TH',
      lat: 13.7236158,
      lng: 100.5143168,
    },
    description: 'Street food, temples, and endless energy! #MandarinOrientalBangkok',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Be sure to take a boat ride along the Chao Phraya River!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Don’t miss the street food at night markets!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Bangkok-Hotels-Mandarin-Oriental.h13953.Hotel-Information',
    hotelName: 'Mandarin Oriental Bangkok',
    images: [
      'thailand.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 12,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Istanbul',
      country_code: 'TR',
      lat: 41.0439752,
      lng: 29.0161433,
    },
    description: 'History, culture, and incredible cuisine in Istanbul. #ÇırağanPalaceKempinski',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'The Bosphorus views are unbeatable!',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Don’t forget to try the Turkish tea by the waterfront!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Istanbul-Hotels-Ciragan-Palace-Kempinski.h12238140.Hotel-Information',
    hotelName: 'Çırağan Palace Kempinski',
    images: [
      'turkey.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 13,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Kyoto',
      country_code: 'JP',
      lat: 34.9936736,
      lng: 135.7594668,
    },
    description: 'Golden pavilions and tranquil gardens – Kyoto is a true dream! #HotelKanraKyoto',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Kyoto is so peaceful! Did you get to wear a kimono?',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Don’t miss the bamboo forest in Arashiyama!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Kyoto-Hotels-Hotel-Kanra-Kyoto.h4132381.Hotel-Information',
    hotelName: 'Hotel Kanra Kyoto',
    images: [
      '13.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 14,
    user_id: 3,
    user_name: 'James Sinclair',
    location: {
      city: 'Cape Town',
      country_code: 'ZA',
      lat: -33.9086313,
      lng: 18.4162905,
    },
    description: 'Table Mountain views and a vibrant city vibe. Cape Town is unforgettable! #OneandOnlyCapeTown',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you visit Robben Island? It’s so moving.',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'South Africa looks incredible. Safari next?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Cape-Town-Hotels-OneOnly-Cape-Town.h2645901.Hotel-Information',
    hotelName: 'One&Only Cape Town',
    images: [
      '14.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 15,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'Sydney',
      country_code: 'AU',
      lat: -33.8604707,
      lng: 151.2035007,
    },
    description: 'Opera House sunsets and Bondi Beach vibes. Australia stole my heart. #TheLanghamSydney',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you try surfing? Bondi’s waves are legendary!',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Sydney Harbour is breathtaking at night.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Sydney-Hotels-The-Langham.h4201865.Hotel-Information',
    hotelName: 'The Langham Sydney',
    images: [
      '15.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 16,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Paris',
      country_code: 'FR',
      lat: 48.86809869999999,
      lng: 2.328893199999999,
    },
    description: 'Romantic strolls along the Seine – Paris, je t’aime. #HôtelRitzParis',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Did you climb the Eiffel Tower or just enjoy the view?',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Paris is always a good idea!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Paris-Hotels-Hotel-Ritz.h122425.Hotel-Information',
    hotelName: 'Hôtel Ritz Paris',
    images: [
      '16.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 17,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'Dubai',
      country_code: 'AE',
      lat: 25.1967363,
      lng: 55.2743371,
    },
    description: 'Living the high life at Burj Khalifa’s doorstep. #ArmaniHotelDubai',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'The Burj view is unmatched! Did you dine at Atmosphere?',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Dubai never stops amazing me.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Dubai-Hotels-Armani-Hotel.h3994618.Hotel-Information',
    hotelName: 'Armani Hotel Dubai',
    images: [
      '17.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 18,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'Santorini',
      country_code: 'GR',
      lat: 36.4315228,
      lng: 25.4244547,
    },
    description: 'Whitewashed walls and endless blue. Santorini is paradise. #KatikiesHotelSantorini',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Oia sunsets are unreal, aren’t they?',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you try the local wine tours? They’re amazing.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Santorini-Hotels-Katikies-Hotel.h1292477.Hotel-Information',
    hotelName: 'Katikies Hotel Santorini',
    images: [
      '18.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 19,
    user_id: 0,
    user_name: 'Dana D',
    location: {
      city: 'Hanoi',
      country_code: 'VN',
      lat: 21.0254125,
      lng: 105.856375,
    },
    description: 'Exploring ancient temples and vibrant streets in Hanoi. #SofitelLegendMetropole',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Did you try pho on the street? It’s the best!',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'The Old Quarter is so full of life!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Hanoi-Hotels-Sofitel-Metropole.h111943.Hotel-Information',
    hotelName: 'Sofitel Legend Metropole',
    images: [
      '19.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 20,
    user_id: 3,
    user_name: 'James Sinclair',
    location: {
      city: 'Rome',
      country_code: 'IT',
      lat: 41.9060378,
      lng: 12.4838,
    },
    description: 'Walking through history in the Eternal City. #HotelHasslerRoma',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Trevi Fountain is even more magical at night!',
      },
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you toss a coin in the fountain for good luck?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Rome-Hotels-Hassler.h422973.Hotel-Information',
    hotelName: 'Hotel Hassler Roma',
    images: [
      '20.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 21,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Vancouver',
      country_code: 'CA',
      lat: 49.28823399999999,
      lng: -123.1166888,
    },
    description: 'Nature meets the city – Vancouver stole my heart! #FairmontPacificRim',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Did you bike around Stanley Park? It’s a must!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Vancouver’s sushi scene is unreal!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Vancouver-Hotels-Fairmont-Pacific.h3191993.Hotel-Information',
    hotelName: 'Fairmont Pacific Rim',
    images: [
      '21.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 22,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Lisbon',
      country_code: 'PT',
      lat: 38.7209776,
      lng: -9.147179099999997,
    },
    description: 'Cobblestone streets, pastel de nata, and stunning sunsets. Lisbon is magical! #TivoliAvenida',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you ride Tram 28? It’s iconic.',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Lisbon is so underrated! Love it.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Lisbon-Hotels-Tivoli-Avenida-Liberdade.h200201.Hotel-Information',
    hotelName: 'Tivoli Avenida Liberdade',
    images: [
      '22.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 23,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'Prague',
      country_code: 'CZ',
      lat: 50.0875423,
      lng: 14.4149159,
    },
    description: 'A fairytale city come to life – Prague is unforgettable. #FourSeasonsPrague',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Did you cross Charles Bridge at sunrise?',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Prague Castle is incredible at sunset!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Prague-Hotels-Four-Seasons-Prague.h13245.Hotel-Information',
    hotelName: 'Four Seasons Prague',
    images: [
      '23.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 24,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'Marrakech',
      country_code: 'MA',
      lat: 31.6215239,
      lng: -7.997488000000001,
    },
    description: 'Vivid colors, bustling souks, and desert sunsets – Marrakech enchants. #LaMamounia',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you visit Jardin Majorelle? It’s a dream!',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'The medina is so vibrant and full of life.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/Marrakech-Hotels-La-Mamounia.h112230.Hotel-Information',
    hotelName: 'La Mamounia',
    images: [
      '24.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 25,
    user_id: 3,
    user_name: 'James Sinclair',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7646318,
      lng: -73.9743251,
    },
    description: 'Central Park in the fall is a dream come true. #ThePlazaHotel',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Central Park is so magical during autumn!',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Did you try the horse carriage rides?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-Plaza.h121.Hotel-Information',
    hotelName: 'The Plaza Hotel',
    images: [
      '25.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 26,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.758019,
      lng: -73.9749745,
    },
    description: 'Top of the Rock views – the best way to see NYC! #LotteNYC',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'NYC from above is breathtaking!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you visit Times Square after?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-Lotte-New-York-Palace.h314.Hotel-Information',
    hotelName: 'Lotte New York Palace',
    images: [
      '26.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 27,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.70227730000001,
      lng: -73.9955854,
    },
    description: 'Exploring the Brooklyn Bridge at sunrise. #1HotelBrooklyn',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'The views of Manhattan from the bridge are incredible!',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Did you walk to Dumbo? It’s so photogenic!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-1-Hotel-Brooklyn-Bridge.h197.Hotel-Information',
    hotelName: '1 Hotel Brooklyn Bridge',
    images: [
      '27.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 28,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7585862,
      lng: -73.98582019999999,
    },
    description: 'Broadway nights and endless lights. NYC never sleeps! #MarriottTimesSquare',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you catch a Broadway show? They’re the best!',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'Times Square is iconic at night.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-Marriott-Marquis-Times-Square.h1457.Hotel-Information',
    hotelName: 'New York Marriott Marquis',
    images: [
      '28.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 29,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.74081380000001,
      lng: -74.00786339999999,
    },
    description: 'Strolling through the High Line – an urban escape. #TheStandardHighLine',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'The High Line is so relaxing, isn’t it?',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'The views of the city from the High Line are amazing.',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-Standard-High-Line.h2302.Hotel-Information',
    hotelName: 'The Standard, High Line',
    images: [
      '29.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 30,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7150355,
      lng: -74.0158397,
    },
    description: 'Modern art and inspiration at MoMA. #ConradNYMidtown',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'The Van Gogh pieces are stunning, aren’t they?',
      },
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you check out the outdoor sculptures?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-Conrad-New-York-Midtown.h312.Hotel-Information',
    hotelName: 'Conrad New York Midtown',
    images: [
      '30.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 31,
    user_id: 0,
    user_name: 'Dana D',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.719181,
      lng: -74.000106,
    },
    description: 'Chinatown eats and Little Italy streets. NYC is full of flavor! #11Howard',
    comments: [
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Chinatown’s dumplings are the best in the world!',
      },
      {
        user_id: 4,
        name: 'Sarah Alali',
        message: 'Did you try the cannoli in Little Italy?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-11-Howard.h243.Hotel-Information',
    hotelName: '11 Howard',
    images: [
      '31.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 32,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7652719,
      lng: -73.97599919999999,
    },
    description: 'Lady Liberty up close – such an inspiring moment. #RitzBatteryPark',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'The ferry ride gives the best views!',
      },
      {
        user_id: 1,
        name: 'Ahmed Khalid',
        message: 'Did you climb to the crown? It’s unforgettable!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-Ritz-Carlton-Battery-Park.h178.Hotel-Information',
    hotelName: 'The Ritz-Carlton Battery Park',
    images: [
      '32.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 33,
    user_id: 4,
    user_name: 'Sarah Alali',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7613979,
      lng: -73.9746128,
    },
    description: 'Shopping till I dropped on Fifth Avenue. #StRegisNYC',
    comments: [
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Fifth Avenue is a shopaholic’s paradise!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you visit the flagship Tiffany & Co.?',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-St-Regis-New-York.h356.Hotel-Information',
    hotelName: 'The St. Regis New York',
    images: [
      '33.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 34,
    user_id: 2,
    user_name: 'Aria Patel',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7249351,
      lng: -73.99851509999999,
    },
    description: 'Jazz nights at the Blue Note – soulful tunes in the city that never sleeps. #BlueNoteNYC',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Blue Note is one of the best jazz clubs in NYC!',
      },
      {
        user_id: 3,
        name: 'James Sinclair',
        message: 'Live jazz in the heart of NYC? Amazing!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-The-Mercer.h444.Hotel-Information',
    hotelName: 'The Mercer',
    images: [
      '34.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 35,
    user_id: 1,
    user_name: 'Ahmed Khalid',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 40.7493819,
      lng: -73.9470833,
    },
    description: 'A picnic with skyline views at Gantry Plaza State Park. #GantryPlaza',
    comments: [
      {
        user_id: 0,
        name: 'Dana D',
        message: 'The Manhattan skyline looks stunning from Gantry Plaza!',
      },
      {
        user_id: 0,
        name: 'Dana D',
        message: 'Did you stay for the sunset? It’s the best!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-LIC-Hotel.h251.Hotel-Information',
    hotelName: 'LIC Hotel',
    images: [
      '35.jpg',
    ],
    pick: true,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
  {
    id: 36,
    user_id: 0,
    user_name: 'Dana D',
    location: {
      city: 'New York',
      country_code: 'US',
      lat: 39.9513077,
      lng: -75.1683958,
    },
    description: 'Holiday magic at Rockefeller Center. NYC feels like a winter wonderland! #RockefellerChristmas',
    comments: [
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'The tree lighting ceremony is so festive!',
      },
      {
        user_id: 2,
        name: 'Aria Patel',
        message: 'Did you go ice skating there? It’s magical!',
      },
    ],
    hotelUrl: 'https://www.expedia.com/New-York-Hotels-Club-Quarters-Rockefeller.h462.Hotel-Information',
    hotelName: 'Club Quarters Hotel, Rockefeller Center',
    images: [
      '36.jpg',
    ],
    pick: false,
    reviews: [
      {
        feature: 'Cleanliness',
        description: 'Very clean and well-maintained rooms.',
      },
      {
        feature: 'Location',
        description: 'Conveniently located near major attractions.',
      },
    ],
  },
];
